<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    id="plus-add.2"
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
  >
    <path id="Path_8088" data-name="Path 8088" d="M0,0H18V18H0Z" fill="none" />
    <path
      id="Path_8089"
      data-name="Path 8089"
      d="M9.75,6.75v6m3-3h-6m3,6.75h0A6.75,6.75,0,0,1,3,9.75H3A6.75,6.75,0,0,1,9.75,3h0A6.75,6.75,0,0,1,16.5,9.75h0A6.75,6.75,0,0,1,9.75,16.5Z"
      transform="translate(-0.75 -0.75)"
      fill="none"
      :stroke="clr ? clr : `#500fe9`"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
  </svg>
</template>
